import { Contract } from './contract';

export class InsuranceCategory {
  name: string;
  insuranceGroups: Array<InsuranceGroup>;
}

export class InsuranceGroup {
  id: number;
  name: string;
  checked?: boolean;
  insuranceGroupType: string;
  insuranceTypes: Array<string>;
}

export class InsuranceProvider {
  id: number;
  name: string;
  checked?: boolean;
  displayName: string;
  spriteCoordinate: any;
}

export class Category {
  categoryId: string;
  background: string;
  color: string;
  categoryName: string;
  parentCategoryName: string;
}

export interface ContractResponse {
  contract: Contract;
}
